module.exports = __webpack_public_path__ + "img/take_course.061b3b80.png";